
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';


import { IconButton, Switch, Tooltip } from '@mui/material';


const EnginesRow = ({ row, updateForm, index, handleActive }) => {
  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.IdCampEngine}
      </TableCell>
      <TableCell align="center" key={index}>{row.Campaign}</TableCell>
      <TableCell align="center" key={index}>{row.Algorithm}</TableCell>
      <TableCell align="center" key={index}>{row.EngDescription}</TableCell>
      <TableCell align="center" key={index}>{row.Calendar}</TableCell>
      <TableCell align="center" key={index}>{row.campaignActive === '1' ? <CheckIcon /> : <CloseIcon />}</TableCell>
      <TableCell align="center">
        <Switch checked={Boolean(Number(row.Active))} onChange={(e, value) => { handleActive(row.IdCampEngine, value) }} />
      </TableCell>

      <TableCell align="center" key={index}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default EnginesRow;